import { useState } from "react";

const SOCIAL_LOGIN_OPTIONS = [
  {
    id: "google",
    label: "Continuar com Google",
    href: "/login/google",
    background: "#ffffff",
    color: "#172554",
    border: "1px solid rgba(255,255,255,0.65)",
    icon: <GoogleIcon />,
  },
  {
    id: "apple",
    label: "Continuar com Apple",
    href: "/login/apple",
    background: "rgba(17, 24, 39, 0.92)",
    color: "#ffffff",
    border: "1px solid rgba(255,255,255,0.14)",
    icon: <AppleIcon />,
  },
];

export const LoginScreen = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleRedirect = (href: string) => {
    window.location.assign(href);
  };

  const handlePhoneLogin = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    window.location.assign("/login/phone");
  };

  return (
    <main
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
        background:
          "radial-gradient(circle at top, #6984ff 0%, #4f69e4 35%, #4860d6 60%, #4054bf 100%)",
        fontFamily:
          '"Segoe UI", "SF Pro Display", -apple-system, BlinkMacSystemFont, sans-serif',
      }}
    >
      <section
        style={{
          width: "100%",
          maxWidth: "470px",
          padding: "28px",
          color: "#ffffff",
        }}
      >
        <div
          style={{
            width: "132px",
            height: "132px",
            margin: "8px auto 28px",
            borderRadius: "38px",
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.18), rgba(255,255,255,0.07))",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.08)",
          }}
        >
          <div
            style={{
              width: "104px",
              height: "104px",
              borderRadius: "32px",
              background:
                "linear-gradient(140deg, #3652d4 0%, #4767ef 54%, #5f7cff 100%)",
              clipPath: "polygon(18% 0%, 100% 50%, 18% 100%, 18% 74%, 0% 74%, 0% 26%, 18% 26%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: "12px",
              boxShadow: "0 18px 44px rgba(30, 52, 150, 0.42)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "999px",
                  background:
                    "conic-gradient(from 215deg, #5eead4, #60a5fa, #4f46e5, #f43f5e, #fb923c, #5eead4)",
                  boxShadow: "0 0 0 3px rgba(255,255,255,0.14)",
                }}
              />
              <div
                style={{
                  fontWeight: 800,
                  letterSpacing: "0.02em",
                  lineHeight: 0.9,
                  fontSize: "15px",
                }}
              >
                <div>ZURY</div>
                <div>LIVE</div>
              </div>
            </div>
          </div>
        </div>

        <header style={{ textAlign: "center", marginBottom: "28px" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "clamp(40px, 5vw, 56px)",
              lineHeight: 1.02,
              fontWeight: 300,
              letterSpacing: "-0.04em",
            }}
          >
            Login com senha
          </h1>
        </header>

        <form onSubmit={handlePhoneLogin}>
          <label
            htmlFor="phone"
            style={{
              display: "block",
              fontSize: "15px",
              fontWeight: 700,
              marginBottom: "10px",
              color: "#f8fbff",
            }}
          >
            Numero de celular
          </label>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              background: "rgba(248, 250, 255, 0.96)",
              borderRadius: "14px",
              padding: "18px 18px",
              boxShadow: "0 8px 26px rgba(37, 52, 129, 0.14)",
            }}
          >
            <span style={{ fontSize: "30px", lineHeight: 1 }}>🇧🇷</span>
            <span
              style={{
                fontSize: "17px",
                fontWeight: 700,
                color: "#0f172a",
              }}
            >
              +55
            </span>
            <input
              id="phone"
              type="tel"
              placeholder="(11) 99999-9999"
              style={inputStyle}
            />
          </div>

          <label
            htmlFor="password"
            style={{
              display: "block",
              fontSize: "15px",
              fontWeight: 700,
              marginTop: "18px",
              marginBottom: "10px",
              color: "#f8fbff",
            }}
          >
            Senha
          </label>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              background: "rgba(248, 250, 255, 0.96)",
              borderRadius: "14px",
              padding: "18px 18px",
              boxShadow: "0 8px 26px rgba(37, 52, 129, 0.14)",
            }}
          >
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              placeholder="Por favor insira a senha"
              style={inputStyle}
            />
            <button
              type="button"
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
              style={{
                border: 0,
                background: "transparent",
                padding: 0,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#7c8698",
              }}
            >
              <EyeIcon />
            </button>
          </div>

          <button
            type="button"
            onClick={() => handleRedirect("/forgot-password")}
            style={{
              marginTop: "12px",
              padding: 0,
              border: 0,
              background: "transparent",
              color: "#ffffff",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Esqueci minha senha
          </button>

          <button
            type="submit"
            style={{
              width: "100%",
              border: 0,
              borderRadius: "18px",
              padding: "18px 20px",
              background:
                "linear-gradient(180deg, rgba(145,156,214,0.9) 0%, rgba(123,135,197,0.92) 100%)",
              color: "#ffffff",
              fontSize: "18px",
              fontWeight: 800,
              cursor: "pointer",
              boxShadow: "0 16px 34px rgba(43, 58, 139, 0.24)",
            }}
          >
            Entrar
          </button>
        </form>

        <div style={{ marginTop: "28px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <div style={dividerStyle} />
            <span
              style={{
                color: "rgba(241, 245, 255, 0.8)",
                fontSize: "13px",
                fontWeight: 700,
                letterSpacing: "0.05em",
                textTransform: "uppercase",
              }}
            >
              Entrar com
            </span>
            <div style={dividerStyle} />
          </div>

          <div style={{ display: "grid", gap: "12px" }}>
            {SOCIAL_LOGIN_OPTIONS.map((option) => (
              <button
                key={option.id}
                type="button"
                onClick={() => handleRedirect(option.href)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "12px",
                  borderRadius: "16px",
                  padding: "16px 20px",
                  background: option.background,
                  color: option.color,
                  border: option.border,
                  cursor: "pointer",
                  boxShadow: "0 10px 28px rgba(34, 46, 117, 0.16)",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                {option.icon}
                <span>{option.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div style={{ marginTop: "26px", textAlign: "center" }}>
          <button
            type="button"
            onClick={() => handleRedirect("/login/sms")}
            style={{
              border: 0,
              background: "transparent",
              color: "rgba(255,255,255,0.82)",
              fontSize: "15px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Login SMS
          </button>

        </div>
      </section>
    </main>
  );
};

const inputStyle: React.CSSProperties = {
  flex: 1,
  border: 0,
  outline: "none",
  background: "transparent",
  color: "#0f172a",
  fontSize: "18px",
  fontWeight: 500,
};

const dividerStyle: React.CSSProperties = {
  flex: 1,
  height: "1px",
  background: "rgba(255,255,255,0.18)",
};

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#EA4335"
        d="M12 10.2v3.9h5.4c-.2 1.2-.9 2.2-1.8 2.9l3 2.3c1.7-1.6 2.7-3.9 2.7-6.6 0-.6-.1-1.2-.2-1.8H12Z"
      />
      <path
        fill="#34A853"
        d="M12 21c2.4 0 4.5-.8 6-2.2l-3-2.3c-.8.6-1.8 1-3 1-2.3 0-4.3-1.6-5-3.7l-3.1 2.4C5.4 19 8.5 21 12 21Z"
      />
      <path
        fill="#4A90E2"
        d="M7 13.8c-.2-.6-.3-1.2-.3-1.8s.1-1.3.3-1.8L3.9 7.8C3.3 9 3 10.5 3 12s.3 3 .9 4.2L7 13.8Z"
      />
      <path
        fill="#FBBC05"
        d="M12 6.5c1.3 0 2.5.4 3.4 1.3L18 5.2C16.5 3.9 14.4 3 12 3 8.5 3 5.4 5 3.9 7.8L7 10.2c.7-2.1 2.7-3.7 5-3.7Z"
      />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12.85 3.5c.82-.99 1.4-2.37 1.24-3.5-1.18.08-2.58.8-3.4 1.78-.74.86-1.38 2.25-1.21 3.56 1.31.1 2.54-.64 3.37-1.84Z"
        fill="currentColor"
      />
      <path
        d="M17.43 15.89c-.4.94-.88 1.8-1.44 2.59-.77 1.09-1.4 1.84-1.9 2.24-.76.66-1.58 1-2.44 1.03-.62 0-1.37-.18-2.24-.53-.88-.36-1.68-.54-2.42-.54-.78 0-1.63.18-2.54.54-.91.35-1.64.54-2.18.57-.83.04-1.66-.3-2.49-1.05-.53-.45-1.19-1.22-1.98-2.33C.9 17.03.18 14.8.02 12.71c-.1-1.25.17-2.44.8-3.55A5.53 5.53 0 0 1 2.8 7.1a5.4 5.4 0 0 1 2.66-.78c.67 0 1.55.21 2.65.63 1.09.42 1.8.63 2.12.63.24 0 1.03-.25 2.35-.75 1.25-.47 2.3-.67 3.15-.6 2.32.19 4.06 1.1 5.2 2.76-2.08 1.27-3.11 3.05-3.09 5.36.02 1.8.67 3.3 1.95 4.49.58.56 1.23.99 1.95 1.28-.16.46-.34.91-.53 1.34Z"
        fill="currentColor"
      />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg width="28" height="20" viewBox="0 0 28 20" fill="none" aria-hidden="true">
      <path
        d="M14 1.5C7.82 1.5 2.55 5.16.5 10c2.05 4.84 7.32 8.5 13.5 8.5S25.45 14.84 27.5 10C25.45 5.16 20.18 1.5 14 1.5Z"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="14" cy="10" r="4.1" stroke="currentColor" strokeWidth="2.2" />
    </svg>
  );
}
